import { TimePeriodType } from "@/models/timePeriod.model";

export const APP_NAME = "Conversation Analytics";

export const CONFIDENCE_MIN_VALUE = 60;

export const BEAMER_TRIGGER_CSS_CLASS = "beamerTrigger";

export const INTERACTION_TYPE_ICONS = {
  inbound: "icon-solid-phone-arrow-down-left",
  outbound: "icon-solid-phone-arrow-up-right",
  transfer: "icon-solid-arrow-right-arrow-left",
  callback: "icon-solid-calendar-day"
};

export enum SORT_DIRECTIONS {
  asc = "Asc",
  desc = "Desc",
  none = "None",
  default = "Desc"
};

export const DEFAULT_SORT_NAME = "RecordingStart";

export const TRANSCRIPT_UNSAVED_CHANGES_WARNING = "Changes made in the transcript may be lost.";

export enum PDF_EXPORT_LAYOUTS {
  all = "all-layout",
  overview = "overview-layout",
  objections = "objections-layout",
  performance = "performance-layout",
  interactions = "interactions-layout",
  sentiment = "sentiment-layout",
  transcription = "transcript-section",
  topics = "topics-layout"
};

export enum DIALOG_CHOICE {
  cancel = 'cancel',
  partial = 'partial',
  oneTime = 'oneTime'
};

export enum DIALOG_RESULT {
  continue = 'continue',
  cancel = 'cancel'
};

export const DATE_RANGE_TYPE = {
  custom: TimePeriodType.custom,
  yesterday: TimePeriodType.yesterday,
  thisWeek: TimePeriodType.thisWeek,
  thisMonth: TimePeriodType.thisMonth
};